import { Component } from '@angular/core';
import { ComponentSubHtmlBase } from '../component-sub-html-base/component-sub-html-base.component';

@Component({
  selector: 'app-component-sub-html-template',
  templateUrl: './component-sub-html-template.component.html',
  styleUrls: ['./component-sub-html-template.component.scss']
})
export class ComponentSubHtmlTemplateComponent extends ComponentSubHtmlBase {

}
